/**
 * AuthSendCaptchaRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AuthSendCaptchaRes
 */
export interface AuthSendCaptchaRes {
  /** 是否成功 */
  success?: boolean
  /** 提示信息 */
  message?: string
  /** 过期时间（秒） */
  expire_in?: string
  /** 下次重试时间（秒） */
  next_retry?: string
}

/**
 * AuthSendCaptchaRes Schema
 */
export const AuthSendCaptchaResSchema: SchemaDefinition = {
  properties: {
    success: {
      description: '是否成功',
      format: 'bool',
      type: 'boolean',
      label: '是否成功',
    },
    message: {
      description: '提示信息',
      format: 'string',
      type: 'string',
      label: '提示信息',
    },
    expire_in: {
      description: '过期时间（秒）',
      format: 'string',
      type: 'string',
      label: '过期时间',
    },
    next_retry: {
      description: '下次重试时间（秒）',
      format: 'string',
      type: 'string',
      label: '下次重试时间',
    },
  },
  type: 'object',
}
